import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useApiError } from "src/hooks/useApiError";
import { getPriceList } from "src/service/pay";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { payPlanInfoAtom, productKeyAtom } from "src/atoms";

interface IUseTotalNxacListProps {
  // product: ProductKey;
  onSuccess?: () => void;
  onError?: () => void;
}
// 제품별 요금제 정보
export function usePriceList({
  // product,
  onSuccess,
  onError,
}: IUseTotalNxacListProps) {
  const { handleError } = useApiError();
  const { goConsole } = useRouter();
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  // const [product, setProduct] = useState<ProductKey>(
  //   getProductFromSessionStorage()
  // );
  const [isAvailable, setIsAvailable] = useState<boolean>(false);
  const [payPlanInfo, setPayPlanInfo] = useRecoilState(payPlanInfoAtom);
  // 상품별 요금제 정보
  // const [isPriceListLoading, setIsPriceListLoading] = useState<boolean>(true);
  const {
    isLoading: isPriceListLoading,
    data: priceList,
    refetch: priceListRefetch,
  } = useQuery(
    ["getPriceList", productKey],
    async () =>
      await getPriceList({
        status: "REAL",
        product: [productKey],
      }),
    {
      enabled: productKey !== null,
      // refetchOnMount: true,
      onSuccess: onSuccess,
      // ? onSuccess
      // : (res) => {
      //     console.log("res", res);
      //     // setIsPriceListLoading(true);
      //     // const productKey = getProductFromSessionStorage();
      //     const payPlanTemp = { ...payPlan };
      //     res?.forEach((price, idx) => {
      //       if (
      //         ["drive", "basic", "plus", "basicPlus", "plusPlus"].includes(
      //           price.priceType
      //         )
      //       ) {
      //         if (price.currency === "WON") {
      //           // @ts-ignore
      //           payPlanTemp[productKey][price.priceType].ko.month =
      //             price.userPerPrice;
      //           // @ts-ignore
      //           payPlanTemp[productKey][price.priceType].ko.year =
      //             price.userPerPriceYear;
      //         } else if (price.currency === "USD") {
      //           // @ts-ignore
      //           payPlanTemp[productKey][price.priceType].en.month =
      //             price.userPerPrice;
      //           // @ts-ignore
      //           payPlanTemp[productKey][price.priceType].en.year =
      //             price.userPerPriceYear;
      //         }
      //       }
      //     });

      //     console.log("payPlanTemp", payPlanTemp);
      //     console.log("test", payPlanTemp["WRAPSODY"]["basic"]["ko"]);
      //     setPayPlanInfo((prev) => ({ ...prev, ...payPlanTemp }));
      //     // setIsPriceListLoading(false);
      //   },
      onError: onError ? onError : handleError,
    }
  );

  return { isPriceListLoading, priceList, priceListRefetch };
}
